<template>
  <div>
    <div v-for="(item, index) in data" :key="item[itemName]">
      <div :class="`pl-3 pr-1 primary d-flex list-item ${index > 0 ? 'mt-3' : ''}`">
        <v-flex xs7 sm7>
          <span v-if="item[itemName] && item[itemName].includes('(HH:mm)')">
            {{ item[itemName].split(' (HH:mm)')[0] }} <span class="time-format-suffix">(HH:mm)</span>
          </span>
          <span v-else>{{ item[itemName] }}</span>
        </v-flex>
        <v-flex xs1 sm1><span>:</span></v-flex>
        <v-flex xs4 class="pl-2">
          <div :class="
            item[itemValue] === 'NO DATA' || item[itemValue] === '-' ? 'error--text no-value' : 
            item[itemValue] === 'Up' ? 'value up-status' : 
             item[itemValue] === 'Down' ? 'value down-status' :
            'number--text value'
          ">  {{ $t(item[itemValue]) }} 
          </div>
        </v-flex>
      </div>
      <v-divider v-if="index < data.length - 1" class="custom-divider ml-15 mr-25" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    itemName: {
      type: String,
      default: 'name'
    },
    itemValue: {
      type: String,
      default: 'value'
    }
  }
}
</script>

<style scoped>

.list-item {
  padding-top: 8px;
  padding-bottom: 8px;
}

.custom-divider {
  background-color: #334079;
}

.no-value {
  font-size: 14px;
  font-weight: 500;
}

.value {
  font-size: 14px;
  font-weight: 500;
}

.up-status {
  color: #24F9AA;
  font-weight: bold; 
}

.down-status {
  color: #FF5252;
  font-weight: bold; 
}

::v-deep .time-format-suffix {
  font-size: 13px;
}
</style>
